import { get, req, post } from '@/plugins/axios'

/**
* 通用翻译接口
* @param {Object} data
*/
export function getTranslationText (data: any):Promise<any> {
  return post('/goods/translate/common', data)
}
